import classNames from 'classnames';
import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "._8EvVU{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;font-family:inherit;font-size:14px;gap:6px;justify-content:center}[dir] ._8EvVU{cursor:pointer}._5UwET{align-items:center;display:flex;height:72px;justify-content:center;width:72px}[dir] ._5UwET:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] ._5UwET._5DAKj{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}._5UwET svg{max-height:46px;max-width:46px}._5DAKj{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}";
var styles = {"selectionListItem":"_8EvVU","selectionListItem_icon":"_5UwET","selectionListItem_icon_selected":"_5DAKj"};
styleInject(css_248z);

const SelectionListItem = ({
  icon,
  label,
  selected,
  children
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.selectionListItem }, icon && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.selectionListItem_icon, {
        [styles.selectionListItem_icon_selected]: selected
      })
    },
    icon
  ), children, label && /* @__PURE__ */ React.createElement("div", { className: styles.selectionListItem_label }, label));
};

export { SelectionListItem as default };
//# sourceMappingURL=SelectionListItem.js.map
